// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3-RN1","inputWrap":"CustomTip_inputWrap__3P9Yy"};